var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgStopSign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.936 2.5L21.5 8.067V15.937L15.936 21.5H8.066L2.5 15.936V8.066L8.066 2.5H15.936ZM15.107 4.5H8.894L4.501 8.895V15.108L8.894 19.502H15.107L19.501 15.108V8.894L15.107 4.501V4.5ZM8 11H16V13H8V11Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgStopSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stop-sign.f9f1de8812c215f2170b50b9773ca993.svg";